module.exports = __webpack_public_path__ + "static/media/jquery.3ce95c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/jquery.jpg
// module id = 101
// module chunks = 0